import React, { Component } from "react"
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp"

import "./scrollToTheTopButton.scss"

class ScrollToTheTopButton extends Component {
  constructor(props) {
    super(props)

    this.state = {
      intervalId: 0,
    }
  }

  scrollFunction = () => {
    const scrollButton = document.querySelector(".scroll")

    if (scrollButton) {
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        scrollButton.style.display = "flex"
      } else {
        scrollButton.style.display = "none"
      }
    } else {
      return null
    }
  }

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId)
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx)
  }

  scrollToTop = () => {
    let intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    )
    this.setState({ intervalId: intervalId })
  }

  componentDidMount() {
    document.onscroll = () => {
      this.scrollFunction()
    }
  }

  render() {
    return (
      <div
        role="button"
        tabIndex={0}
        className="scroll"
        style={this.props.captcha ? { bottom: 90 } : {}}
        onClick={() => {
          this.scrollToTop()
        }}
        onKeyDown={() => {
          this.scrollToTop()
        }}
      >
        <KeyboardArrowUpIcon />
      </div>
    )
  }
}

export default ScrollToTheTopButton
